import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../store";
import {useEffect, useRef, useState} from "react";
import {wsapi} from "../../../api/wsapi";
import Header from "../../../navigation/Header";
import Interaction from "../interaction/Interaction";
import {useTranslation} from "react-i18next";

import {DirectionChange, LightPathType, LightShape, TherapyConfiguration, TherapyState} from "../therapy-configuration";
import {
    setTherapyConfiguration
} from "../therapyConfigurationSlice";
import "./VisitorSession.css";
import {getInteractionClassName} from "./visitor-session-theme";
import {VideoCallPanel, useVideoCall, isVideoEnabled} from "../../../../video";
interface VisitorSessionProps {
    sessionId: string;
}

const VisitorSession: React.FC<VisitorSessionProps> = ({sessionId}) => {
    const [isTherapistJoined, setIsTherapistJoined] = useState<boolean>(false);
    const {t} = useTranslation();

    // const profileData = useSelector((state: RootState) => state.profile);

    const therapyConfiguration = useSelector((state: RootState) => state.therapyConfiguration);

    // Patient answers the therapist's call. During a BLS set the patient's view
    // hides the video so they focus on the moving light (the camera keeps
    // capturing, so the therapist still observes them).
    const videoEnabled = isVideoEnabled();
    const isMovementActive = therapyConfiguration.state === TherapyState.inProgress;
    const { state: videoState, localStream, remoteStream } = useVideoCall({
        enabled: videoEnabled,
        isInitiator: false,
        peerPresent: isTherapistJoined,
    });

    // const therapyConfiguration = useSelector((state: RootState) => state.therapyConfiguration);
    const dispatch = useDispatch();
    useEffect(() => {
        wsapi().emit('joinSession', { session: 'session-' + sessionId, role: "client" });
        // wsapi().emit('joinSession', { session: 'session-' + sessionId, role: "client" });

        wsapi().on('configurationChange', (message) => {
            const newConfiguration = message.therapyConfiguration;
            // console.log('Received message from server:', message);
            dispatch(setTherapyConfiguration(newConfiguration));
        });

        wsapi().on('therapistJoined', (message) => {
            setIsTherapistJoined(true);
        });
        wsapi().on('therapistDisconnected', (message) => {
            setIsTherapistJoined(false);
        });
        document.body.style.overflow="hidden";
    }, [])
    return <div>
        {/*Visitore id: {sessionId}*/}
        <div className={getInteractionClassName(therapyConfiguration.colorPreset)}>
            <Interaction isOppositePersonJoined={isTherapistJoined} />
            {isTherapistJoined ?
            <div className={"session-status"}><span className={"status-pill status-connected"}>{t("session in progress")}</span></div>
                :
            <div className={"session-status waiting-therapist"}><span className={"status-pill status-waiting"}>{t("waiting for therapist to join")}</span></div>
            }
        </div>
        {videoEnabled &&
            <VideoCallPanel
                variant="patient"
                state={videoState}
                localStream={localStream}
                remoteStream={remoteStream}
                hiddenForFocus={isMovementActive}
            />
        }
    </div>
}
export default VisitorSession;
